import {gsap} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";
import Header from "./Header";

export default class HeaderFull {

	static init() {
		this.header = document.querySelector(".header-main-full");
		if (this.header) {
			Header.init();
			this.initSubnav();
			GlobalVariables.resizeCallbacks.push(this);
		}
	}
	static initSubnav(){

		this.menuLevelOne = this.header.querySelectorAll('.menu-item--lev1.menu-item-has-children');
		this.menuLevelTwo = this.header.querySelectorAll('.menu-item--lev2');
		this.menuLevelTwoImages = this.header.querySelectorAll('.menu-item--lev2 img');
		this.hoverTimeout = 150;

		if( window.innerWidth < 992 ) {

			this.menuLevelOne.forEach((item) => {
				let subNav = item.querySelector('.lev2');
				subNav.style.height = "auto";
				subNav.dataset.height = subNav.offsetHeight;
				subNav.style.height = 0;
				item.classList.remove("subnav-open");
				item.querySelector(":scope > a").addEventListener("click", Header.openSubNavBurger );
			});

		}else{

			let event = ( document.documentElement.classList.contains('touchevents') ) ? "click" : "mouseenter";

			this.menuLevelOne.forEach((item) => {

				let subNav = item.querySelector('.lev2');
				subNav.style.height = "50svh";
				item.classList.remove("subnav-open");

				if( subNav ){
					item.addEventListener("mouseenter", (e) => {
						item.querySelector(':scope a').addEventListener(event, (e) => {
							e.preventDefault();
						});
						if (this.timeoutActive) {
							clearTimeout(this.leaveTimeout);
							clearTimeout(this.enterTimeout);
							this.enterTimeout = setTimeout(() => {
								this.menuLevelOne.forEach((item) => {
									let subNav = item.querySelector('.lev2');
									subNav.classList.remove('active');
								});
								GlobalVariables.smoother.paused(true);
								document.body.classList.add('header-menu-subnav-open');
								subNav.classList.add('active');
							}, this.hoverTimeout);
						} else {
							GlobalVariables.smoother.paused(true);
							document.body.classList.add('header-menu-subnav-open');
							subNav.classList.add('active');
						}
					});
					item.addEventListener("mouseleave", () => {
						this.timeoutActive = true;
						this.leaveTimeout = setTimeout( () => {
							GlobalVariables.smoother.paused(false);
							document.body.classList.remove('header-menu-subnav-open');
							subNav.classList.remove('active');
							this.timeoutActive = false;
						}, this.hoverTimeout );
					});
					item.removeEventListener("click", Header.openSubNavBurger);
				}

			});

			this.menuLevelTwo.forEach((item) => {

				let img = item.querySelector('img');

				item.addEventListener("mouseenter", () => {
					this.menuLevelTwoImages.forEach((img) => {
						gsap.to(img,{
							opacity: 0,
							duration: 0.3
						});
					});
					gsap.to(img,{
						opacity: 1,
						duration: 0.3
					});
				});
				item.addEventListener("mouseleave", () => {
					gsap.to(img,{
						opacity: 0,
						duration: 0.3
					});
					gsap.to(this.menuLevelTwoImages[0],{
						opacity: 1,
						duration: 0.3
					});
				});

			});

			Header.header.addEventListener('mousemove', () => {
				if( !this.headerMouseMove ){
					this.makeHeaderAsBannerTheme();
					this.headerMouseMove = true;
				}
			});

			Header.header.addEventListener('mouseleave', () => {
				if( this.timeoutActive ){
					setTimeout(() => {
						this.restoreHeaderTheme();
					}, 600);
				} else {
					this.restoreHeaderTheme();
				}
			});

		}

	}

	static makeHeaderAsBannerTheme() {
		if (Header.header.classList.contains("is-on-top")) {
			Header.removeClassByPrefix(Header.header, 'section');
			Header.header.classList.add('section');
			Header.header.classList.add(Header.header.dataset.sectionColor);
		}
	}
	static restoreHeaderTheme() {
		if (Header.header.classList.contains("is-on-top")) {
			Header.header.className = Header.headerClass;
			this.headerMouseMove = false;
		}
	}

	static resize(){

		this.initSubnav();
		if (window.innerWidth > 991) {
			document.body.classList.remove("nav-main-open");
			GlobalVariables.smoother.paused( false );
		}

	}
}
